export interface SelectOption {
  id: number
  label: string
  association: number
}

export interface SelectOptGroupOption {
  uuid: number
  name: string
}

export const fakeOptions: SelectOption[] = [
  { id: 1, label: 'Option Example Uno', association: 1 },
  { id: 2, label: 'Item Deux 2', association: 2 },
  { id: 3, label: 'Three Three Three', association: 1 },
  {
    id: 4,
    label: 'Next Item In List Is Design System Design System',
    association: 2,
  },
  { id: 5, label: '5 Entries', association: 2 },
  {
    id: 6,
    label:
      'Another Option With A Longer Amount of Important Information To Read',
    association: 3,
  },
]

export const fakeOptGroups: SelectOptGroupOption[] = [
  { uuid: 1, name: 'Group 1' },
  {
    uuid: 2,
    name: 'Group Having a Longer Group Label, Group Two Is That Group',
  },
  { uuid: 3, name: 'Group 3' },
]
